export const SERVICE_INFO_QUERY_KEY = 'service-info';
